import React from 'react';
import { DataLayer } from '../../../lib/types';
import { LayerHeader } from './LayerHeader';

interface ComingSoonPlaceholderProps {
  layer: DataLayer;
}

export const ComingSoonPlaceholder: React.FC<ComingSoonPlaceholderProps> = ({ layer }) => {
  const badgeLabel =
    layer.status === 'in_development' ? 'In Development'
    : layer.status === 'planned' ? 'In Queue'
    : 'Coming Soon';
  const badgeColor =
    layer.status === 'in_development'
      ? 'bg-yellow-500/20 text-yellow-400'
      : 'bg-neutral-500/20 text-neutral-400';

  return (
    <div className="space-y-6">
      <LayerHeader layer={layer} />
      <div className="bg-figma-card rounded-figma-panel p-5 border border-figma-lime/30 shadow-figma-card">
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-figma-lime flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
          <div className="space-y-2">
            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-roboto font-semibold ${badgeColor}`}>
              {badgeLabel}
            </span>
            {layer.statusNote && (
              <p className="text-xs font-roboto text-neutral-400 leading-relaxed">
                {layer.statusNote}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
